<div class="modal-body customModalBody">
    <!-- <div class="modal-header customBlueHeader">
        <p class="modal-title">Add Test</p>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->

      <div class="modal-header customBlueHeader">
        <p class="modal-title">Add Test</p>
        <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button> -->

        <button type="button" class="close" aria-label="Close" (click)="modelClose()">
            <span aria-hidden="true">&times;</span>
          </button>
      </div>
    <!-- <div appAutoFocus [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div> -->
    <div class="alert alert-success text-center mrg-top-10" role="alert" *ngIf="isSuccessMsg">
        {{msg}}
      </div>
      <div class="alert alert-danger text-center mrg-top-10" role="alert" *ngIf="isFailureMsg">
        {{msg}}
      </div>
    <form [formGroup]="addTestForm" (ngSubmit)="addTestNameData(addTestForm)">
        <div class="form-group">
            <label>Diagnostics Centre Name</label>
            <input type="text" class="form-control col-form-label-sm" readonly formControlName="diagnosticscentrename" placeholder="Diagnostics Centre Name">
        </div>
        <div class="form-group">
            <label>Associate Code</label>
            <input type="text" class="form-control col-form-label-sm" readonly formControlName="associatecode" placeholder="2,500">
        </div>
        <div class="form-group">
            <label>Test Name</label>
            <!-- <select class="form-control col-form-label-sm">
                <option>Select</option>
                <option>...</option>
            </select> -->
            <input type="text" (keyup)="getTestNameValues($event)" list="testNameList" class="form-control col-form-label-sm"  (blur)="getPrice()" id="testNameId" formControlName="testname"/>
            <datalist id="testNameList" aria-autocomplete="both">
                <option *ngFor="let item of testNameList" [value]="item.name">{{item.name}}</option>
              </datalist>
        </div>
       
        <div class="form-group">
            <label>Test Price</label>
            <input type="text" class="form-control col-form-label-sm" id="price" formControlName="price" placeholder="2,500" readonly>
        </div>

        <!-- <div class="form-group">
            <label>Comments</label>
            <textarea class="form-control col-form-label-sm"></textarea>
        </div> -->
        <div class="modal-footer customModalFooter bdr-none">
            <!-- <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Add</button> -->
            <button class="btn green_btn" type="submit">Add</button> 
        </div>

    </form>



</div>